import { ref } from 'vue';

export const sharedState = {
  mostrarComponentPrincipal: ref(false),
  mostrarComponentSecundario: ref(false),
  mostrarComponentTerciario: ref(false),

  mostrarComponentArmasPrincipal: ref(false),
  mostrarComponentArmasDetalles: ref(false),
  mostrarComponentAsignacionPrincipal: ref(false),

  
  loadingComponentPersonal: ref(false),
  loadingComponentArmas: ref(false),
};
